import React, {useState} from 'react'
import styled from 'styled-components'
import CSSKeys from './CSSPropertiesKeys'

function CSSPreparation(props) {

    const[styles,setStyles] = useState();
    
    if(props.stylingData){
        var stylingData = props.stylingData;

        var styling = {};
        Object.keys(stylingData).forEach((key) => {
             
                if(Object.keys(CSSKeys).includes(key)){
                    styling[CSSKeys[key]] = stylingData[key];
             }
                else {
                    styling[key] = stylingData[key];
             }
        })

         props.setStylingData(styling);                      
       
    }
    return (<></>); 

}

export default CSSPreparation;